const state = {
  main_header: {
    name: "",
    heading_id: "",
    heading_en: "",
    sub_heading_id: "",
    sub_heading_en: "",
    image_desktop_jpg: "",
    image_mobile_jpg: "",
    is_with_button: false,
    button_text_id: "",
    button_text_en: "",
    button_url_desktop: "",
    button_url_mobile: "",
    image_desktop: "",
    image_mobile: ""
  },
  main_header_id: [],
};

export default state;
